import { useStyles } from '@archipro-design/aria';
import { useClickAway } from 'ahooks';
import React from 'react';
import type AttributeOption from '@modules/product/type/attribute-option';
import ColorOption from './ColorOption';
import * as S from './ColorSelectorPopup.style';

interface ColorSelectorPopupProps {
    data: {
        options: AttributeOption[];
        selected: number;
    };
    onOptionSelect(optionID: number): void;
    onClose(): void;
}

const ColorSelectorPopup = ({
    data: { options, selected },
    onOptionSelect,
    onClose,
}: ColorSelectorPopupProps) => {
    const { css } = useStyles();
    const ref = React.useRef<HTMLDivElement>(null);
    useClickAway(() => {
        onClose();
    }, ref);
    return (
        <div className={css(S.ColorSelectorPopup)} ref={ref}>
            <div className={css(S.PopupTitle)}>Select colour</div>
            <div className={css(S.ColorGrid)}>
                {options.map((opt) => (
                    <ColorOption
                        key={opt.ID}
                        data={{ option: opt }}
                        selected={opt.ID === selected}
                        onSelect={(opt) => onOptionSelect(opt.ID)}
                    />
                ))}
            </div>
        </div>
    );
};

export default ColorSelectorPopup;
